module.exports = __webpack_public_path__ + "img/Lepus.97cccf26.png";